import { Link } from 'react-router-dom';

const services = [
  { name: 'AI業務改善', to: '/services/ai-improvement/' },
  { name: 'AIシステム開発', to: '/services/system-development/' },
  { name: 'AI運用・改善支援', to: '/services/ai-operation/' },
  { name: 'AI集客支援', to: '/services/ai-marketing/' },
  { name: 'Luvira ASA', to: '/services/ai-security/' },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-[#2a2a3e] bg-[#12121f]">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src="https://media.genaiweb.ai/1cfcb9a7-5410-444f-8143-602b7e61a697/logo.png"
                alt="株式会社ルヴィラ"
                className="h-10 w-auto brightness-0 invert"
              />
            </Link>
            <p className="mt-4 text-sm text-[#a0a0b0] leading-relaxed max-w-sm">
              株式会社ルヴィラは、AIを活用して会社の成長を妨げる業務・情報・判断の滞りを見つけ、改善につなげるパートナーです。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">サービス</h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.to}>
                  <Link to={s.to} className="text-sm text-[#a0a0b0] hover:text-white transition-colors cursor-pointer">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">会社情報</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/company/" className="text-sm text-[#a0a0b0] hover:text-white transition-colors cursor-pointer">
                  会社情報
                </Link>
              </li>
              <li>
                <Link to="/news/" className="text-sm text-[#a0a0b0] hover:text-white transition-colors cursor-pointer">
                  ニュース
                </Link>
              </li>
              <li>
                <Link to="/blog/" className="text-sm text-[#a0a0b0] hover:text-white transition-colors cursor-pointer">
                  ブログ
                </Link>
              </li>
              <li>
                <Link to="/contact/" className="text-sm text-[#a0a0b0] hover:text-white transition-colors cursor-pointer">
                  お問い合わせ
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-[#a0a0b0] hover:text-white transition-colors cursor-pointer">
                  プライバシーポリシー
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#2a2a3e] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#7a7a8a]">© 2024 株式会社ルヴィラ</p>
          <div className="flex items-center gap-4">
            <a href="#" aria-label="X" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#2a2a3e] bg-[#1a1a2e] text-[#a0a0b0] hover:text-white hover:border-[#7c3aed]/50 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line"></i>
            </a>
            <a href="#" aria-label="LinkedIn" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#2a2a3e] bg-[#1a1a2e] text-[#a0a0b0] hover:text-white hover:border-[#7c3aed]/50 transition-colors cursor-pointer">
              <i className="ri-linkedin-line"></i>
            </a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#2a2a3e] bg-[#1a1a2e] text-[#a0a0b0] hover:text-white hover:border-[#7c3aed]/50 transition-colors cursor-pointer">
              <i className="ri-facebook-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}